import { render, staticRenderFns } from "./StallionStocksNormes.vue?vue&type=template&id=2b81094c&"
import script from "./StallionStocksNormes.vue?vue&type=script&lang=js&"
export * from "./StallionStocksNormes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports